var $cartNotesFields = $('.section-gift-message .form-gift-wrap .field');
var $cartNote = $(".js-cdd-cart-form .cart-note");

$('.section-gift-message .section__head-choice input').on('change', function() {
  var $this = $(this);
  var $sectionOptions = $('.section-gift-message .section__body');

  if ($this.val() === 'show') {
    $sectionOptions.slideDown();
  } else {
    $sectionOptions.slideUp();
  }
});

$('input[name=gift-wrap]').on('click', function(){
  //$('#attributes-gift-wrap').val($('input[name=gift-wrap]:checked').val());
  $('#attributes-gift-wrap').val($(this).val());
});
$('input[name=gift-ship-wrap]').on('click', function(){
  //$('#attributes-gift-wrap').val($('input[name=gift-wrap]:checked').val());
  $('#attributes-gift-wrap-ship').val($(this).val());
});

$('#show-gift-wrap').on('click',function(){
  if($(this).is(':checked')){
    $('#attributes-gift-wrap-content').val($('#cart-attribute-gift').val());
	$('input[name=gift-wrap]').each(function(){
      if($(this).is(':checked')){
        $('#attributes-gift-wrap').val($(this).val());
      }
    });
  }else{
    $('#attributes-gift-wrap').val('');
    $('#attributes-gift-wrap-content').val('');
  }
});
$('#show-gift-wrap').on('click',function(){
  if($(this).is(':checked')){
	  $('input[name=gift-ship-wrap]').each(function(){
      if($(this).is(':checked')){
        $('#attributes-gift-wrap-ship').val($(this).val());
      }
    });
  }else{
    $('#attributes-gift-wrap-ship').val('');
  }
});

$('#cart-attribute-gift').on('blur', function(){
  $('#attributes-gift-wrap-content').val($(this).val());
});

$cartNotesFields.on('blur', function() {
  var id = $(this).attr('id');
  $('#attributes-'+id).val($(this).val());
});
/* 
$cartNotesFields.on('keyup', function() {
  var currentNote = '';

  $cartNotesFields.each(function() {
    var $this = $(this);

    if ($this.val().length > 0) {
      currentNote += $this.val() + ' @ ';
    }
  });

  currentNote = currentNote.replace(/\s@\s$/, '');
  $cartNote.val(currentNote);
});
*/
//gift message content
$('.gift-message-content ').slideUp();
$('#show-gift-message').click(function(){
    if($(this).prop("checked") == true){
        $('.gift-message-content ').slideDown();
		$('#attributes-message').val('希望する');
        $('.form__row .field').each(function(){
          $('#attributes-'+$(this).attr('id')).val($(this).val());
        });
    }
    else if($(this).prop("checked") == false){
      $('.gift-message-content ').slideUp();
      $('#attributes-message').val('');
      $('.form__row .field').each(function(){
        //alert($(this).attr('id'));
        $('#attributes-'+$(this).attr('id')).val('');
      });
    }
});

$('#cart-note').on('blur', function(){
  $('input[name=note]').val($(this).val());
});

$(document).on("click", '.option-toggle', function (e) {
  e.preventDefault();
  var target = $(this).attr('href');
  $(target).slideToggle();
});

// 共通ギフトラップ関数群
// 既に定義済みの場合は再定義しない
window.GiftWrap = window.GiftWrap || (function() {
  // 二重送信ガード（主対策）: addItems を呼ぶ全入口の同時 /cart/add.js を1本に制限する
  var _addInFlight = false;

  function addItems(items, onSuccess, onError) {
    if (!Array.isArray(items) || items.length === 0) return;
    if (_addInFlight) return; // 実行中なら2本目以降を無視（包装料2重計上の防止）
    _addInFlight = true;
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: { items: items },
      dataType: 'json',
      success: function() {
        if (typeof onSuccess === 'function') {
          try { onSuccess(); } catch (e) {}
        } else {
          location.href = '/cart';
        }
      },
      error: function() {
        // 失敗を呼び出し元へ通知（呼び出し元はボタンを再活性化して再操作可能にする）
        if (typeof onError === 'function') {
          try { onError(); } catch (e) {}
        }
      },
      complete: function() {
        // 成否どちらでもロック解除（成功時はデフォルトで /cart へ遷移するため解除前に画面が切替わる）
        _addInFlight = false;
      }
    });
  }

  function buildGiftWrapItems(variantId, propertiesList) {
    if (!variantId) return [];
    var items = [];
    if (!Array.isArray(propertiesList)) {
      propertiesList = [propertiesList];
    }
    for (var i = 0; i < propertiesList.length; i++) {
      if (!propertiesList[i] || typeof propertiesList[i] !== 'object') continue;
      items.push({ quantity: 1, id: variantId, properties: propertiesList[i] });
    }
    return items;
  }

  function removeAllByKeys(itemKeyMap, onSuccess) {
    if (!itemKeyMap || typeof itemKeyMap !== 'object') return;
    $.ajax({
      type: 'POST',
      url: '/cart/update.js',
      data: { updates: itemKeyMap },
      dataType: 'json',
      success: function() {
        if (typeof onSuccess === 'function') {
          try { onSuccess(); } catch (e) {}
        } else {
          location.href = '/cart';
        }
      }
    });
  }

  return {
    addItems: addItems,
    buildGiftWrapItems: buildGiftWrapItems,
    removeAllByKeys: removeAllByKeys
  };
})();

// all-gift-remove 共通委譲バインド
$(document).on('click', '.all-gift-remove', function() {
  try { localStorage.setItem('giftwrappingremove', 'removed'); } catch (e) {}
  var giftRemovers = {};
  $('.gift-item-keys').each(function () {
    var itemKey = $(this).text();
    giftRemovers[itemKey] = 0;
  });
  if (window.GiftWrap && typeof GiftWrap.removeAllByKeys === 'function') {
    GiftWrap.removeAllByKeys(giftRemovers);
  }
});

// ギフトラップ消去後のスクロール（共通）
$(function(){
  try {
    var val = localStorage.getItem('giftwrappingremove');
    if (val === 'removed') {
      var $target = $('.gift-removed-after');
      if ($target.length) {
        $('html,body').animate({ scrollTop: $target.offset().top - 60 });
      }
      localStorage.removeItem('giftwrappingremove');
    }
  } catch (e) {}
});